
export enum Currencies {
  CURRENCY_USD = "USD",
  CURRENCY_EUR = "EUR",
  CURRENCY_GBP = "GBP",
  CURRENCY_CHF = "CHF",
  CURRENCY_SGD = "SGD",
  CURRENCY_IDR = "IDR",
  CURRENCY_CAD = "CAD",
  CURRENCY_AUD = "AUD",
  CURRENCY_PHP = "PHP",
  CURRENCY_THB = "THB",
  CURRENCY_MYR = "MYR"
}

export const DEFAULT_CURRENCY_SUB_UNITS = 100;

export const DEFAULT_CURRENCY = Currencies.CURRENCY_USD;

export const EU_COUNTRIES = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE"
];

export function getCurrencyFromCountryCode(
  countryCode: string | null | undefined
): Currencies {
  if (!countryCode) {
    return Currencies.CURRENCY_USD;
  }

  const upperCountryCode = countryCode.toUpperCase();

  if (EU_COUNTRIES.includes(upperCountryCode)) {
    return Currencies.CURRENCY_EUR;
  }

  if (upperCountryCode === "GB" || upperCountryCode === "UK") {
    return Currencies.CURRENCY_GBP;
  }

  if (upperCountryCode === "CH") {
    return Currencies.CURRENCY_CHF;
  }

  if (upperCountryCode === "SG") {
    return Currencies.CURRENCY_SGD;
  }

  if (upperCountryCode === "ID") {
    return Currencies.CURRENCY_IDR;
  }

  if (upperCountryCode === "CA") {
    return Currencies.CURRENCY_CAD;
  }

  if (upperCountryCode === "AU") {
    return Currencies.CURRENCY_AUD;
  }

  if (upperCountryCode === "PH") {
    return Currencies.CURRENCY_PHP;
  }

  if (upperCountryCode === "TH") {
    return Currencies.CURRENCY_THB;
  }

  if (upperCountryCode === "MY") {
    return Currencies.CURRENCY_MYR;
  }

  return Currencies.CURRENCY_USD;
}